var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:`switch-input-wrapper ${_vm.size == 'sm' ? 'switch-input-wrapper--small' : ''}`},[_c('input',{ref:"switch-input",attrs:{"type":"checkbox"},on:{"change":_vm.toggleSwitch}}),_c('span',{staticClass:"switch-input-wrapper__slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }